import React from 'react';

const SubHeading = ({ title }) => (
  <p className="eyebrow">{title}</p>
);

export default SubHeading;
